import { useQuery } from "react-query";
import Cookies from "js-cookie";
import { serverBaseUrl } from "../config/envs";

const getStandardFieldById = async (token, id) => {
  let headers = {
    "Content-Type": "application/json",
  };
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  const url = new URL(`${serverBaseUrl}/get_standard_field?id=${id}`);

  try {
    const response = await fetch(url.toString(), { headers });

    if (!response.ok) {
      let errorData = {
        status: response?.status,
        message: response?.statusText,
      };

      try {
        const json = await response.json();
        errorData.message = json.message || errorData.message;
        errorData.messageCode = json.messageCode;
        errorData.data = json.data;
        errorData.success = json.success;
      } catch (jsonError) {
        console.error("Failed to parse JSON error response:", jsonError);
      }

      throw new Error(JSON.stringify(errorData));
    }

    const data = await response.json();

    return data?.data;
  } catch (error) {
    console.log(error, "from catch");
    throw error;
  }
};

export const useGetStandardFieldById = (id) => {
  const token = Cookies.get("token");

  return useQuery(
    ["get_fields_by_id", token, id],
    () => getStandardFieldById(token, id),
    {
      refetchOnWindowFocus: true,
      retry: false,
      keepPreviousData: false,
      enabled: !!id,
    }
  );
};
